import { TrackedLink } from "@components/analytics/TrackedLink";
import Breadcrumbs from "@components/Breadcrumbs";
import { ImgSrc } from "@config/image";
import { Container, Row, Col } from "react-grid-system";

const Starnote = () => (
  <>
    <Container className="landingGridContainer">
      <Row>
        <Col md={12} lg={8}>
          <Breadcrumbs
            links={[
              { name: "Docs", url: "/docs" },
              { name: "Starnote", url: "/starnote" },
            ]}
          />
          <h1>Starnote</h1>
          <p>
            The hub for documentation on building Notecard solutions that use 
            Starnote for satellite data transmission. Learn how to get started 
            with Starnote, consult the datasheet for technical details, and 
            learn about best practices when integrating Starnote.
          </p>
        </Col>
      </Row>

      <hr />
      <h2>Starnote Resources</h2>

      <Row>
        <Col>
          <div className="landing-page-link-list">
            <div>
              <img alt="" src={ImgSrc("/images/icons/docs/reference.svg")} />
              <h4>Starnote Quickstart</h4>
              <p>
                A quickstart tutorial for getting up and running with a Blues
                Starnote for satellite IoT connectivity.
              </p>
              <TrackedLink
                href="/quickstart/starnote-quickstart"
                className="landingLink"
              >
                Learn more
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/notecard-solutions.svg")}
              />
              <h4>Starnote Datasheet</h4>
              <p>
                Detailed reference document for Starnote, including pinouts and 
                hardware specifications.
              </p>
              <TrackedLink
                href="/datasheets/starnote-datasheet"
                className="landingLink"
              >
                Learn more
              </TrackedLink>
            </div>

            <div>
              <img
                alt=""
                src={ImgSrc("/images/icons/docs/firmware-libraries.svg")}
              />
              <h4>Starnote Best Practices</h4>
              <p>
                  Learn some tips and tricks for building a product around the 
                  Notecard and Starnote.
              </p>
              <TrackedLink
                href="/starnote/starnote-best-practices"
                className="landingLink"
              >
                Learn more
              </TrackedLink>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </>
);

export default Starnote;
